import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { FixedSizeGrid as Grid } from 'react-window';
import { Image } from '@outdoor-voices/ui';
import { isTabletSmall } from '@outdoor-voices/ui/dist/utils/dom/isMobile';
import { useQuery } from 'urql';
import { useRef } from 'react';
import PropTypes from 'prop-types';
import windowWidth from '@outdoor-voices/ui/dist/utils/dom/windowWidth';
import { REVIEWS_PHOTOS } from './queries';
import css from './PhotosView.module.scss';
import windowHeight from '../../utils/dom/windowHeight';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var PhotosView = function PhotosView(_ref) {
  var closeButton = _ref.closeButton,
      on = _ref.on,
      onSetReview = _ref.onSetReview,
      orderBy = _ref.orderBy,
      productShopifyId = _ref.productShopifyId,
      title = _ref.title;

  var _useQuery = useQuery({
    query: REVIEWS_PHOTOS,
    variables: {
      orderBy: orderBy,
      productShopifyId: productShopifyId
    }
  }),
      _useQuery2 = _slicedToArray(_useQuery, 1),
      _useQuery2$ = _useQuery2[0],
      data = _useQuery2$.data,
      fetching = _useQuery2$.fetching;

  var gridRef = useRef(null);
  var rootRef = useRef(null);
  var isMobile = isTabletSmall();
  var modalPadding = isMobile ? 12 : 96 * 2;
  var modalMargin = isMobile ? 0 : 72 * 2;
  var width = Math.min(1088, gridRef.current ? gridRef.current.clientWidth : windowWidth() - (modalPadding + modalMargin));
  var cols = isMobile ? 3 : 4;
  var fetchingRows = isMobile ? 6 : 3;
  var rows = fetching ? fetchingRows : Math.ceil(data.reviews.edges.length / cols);
  var dimension = width / cols;
  var tabIndex = on ? 0 : -1;
  var tarH = 250;
  var height = rootRef.current ? rootRef.current.parentElement.clientHeight - gridRef.current.offsetTop : windowHeight() - tarH; // eslint-disable-next-line react/prop-types

  var Cell = function Cell(_ref2) {
    var columnIndex = _ref2.columnIndex,
        rowIndex = _ref2.rowIndex,
        style = _ref2.style;
    var edge = data.reviews.edges[rowIndex * cols + columnIndex];

    if (!edge) {
      return false;
    }

    return /*#__PURE__*/_jsx("div", {
      className: css.itemWrap,
      style: style,
      children: /*#__PURE__*/_jsx("button", {
        "aria-label": "Click to view this review",
        type: "button",
        className: css.item,
        onClick: function onClick() {
          onSetReview({
            id: edge.node.id
          });
        },
        tabIndex: tabIndex,
        children: /*#__PURE__*/_jsx("div", {
          className: css.image,
          children: /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, edge.node.image), {}, {
            alt: "A customer named ".concat(edge.node.name, " wearing ").concat(title, " - ").concat(edge.node.image.alt),
            crop: true,
            sizes: [104, 238],
            width: Math.min(476, edge.node.image.width),
            wrap: false
          }))
        })
      })
    });
  }; // eslint-disable-next-line react/prop-types


  var CellLoader = function CellLoader(_ref3) {
    var style = _ref3.style;
    return /*#__PURE__*/_jsx("div", {
      className: css.itemWrap,
      style: style,
      "aria-busy": "true",
      children: /*#__PURE__*/_jsx("div", {
        className: css.item,
        "aria-hidden": "true",
        children: /*#__PURE__*/_jsx("div", {
          className: css.image
        })
      })
    });
  };

  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    ref: rootRef,
    children: [/*#__PURE__*/_jsxs("div", {
      className: css.header,
      children: [closeButton, /*#__PURE__*/_jsx("h2", {
        className: css.title,
        children: "All Photos"
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: css.grid,
      id: "all-photos",
      ref: gridRef,
      children: [fetching && /*#__PURE__*/_jsx(Grid, {
        columnCount: cols,
        columnWidth: dimension,
        height: height,
        rowCount: rows,
        rowHeight: dimension,
        width: width,
        children: CellLoader
      }), !fetching && data && /*#__PURE__*/_jsx(Grid, {
        columnCount: cols,
        columnWidth: dimension,
        height: height,
        rowCount: rows,
        rowHeight: dimension,
        width: width,
        children: Cell
      })]
    })]
  });
};

PhotosView.propTypes = {
  closeButton: PropTypes.node,
  on: PropTypes.bool.isRequired,
  onSetReview: PropTypes.func.isRequired,
  orderBy: PropTypes.string.isRequired,
  productShopifyId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  title: PropTypes.string.isRequired
};
export default PhotosView;